import script from "./HeaderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderModal.vue?vue&type=script&setup=true&lang=js"

import "./HeaderModal.vue?vue&type=style&index=0&id=07ef5d3f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07ef5d3f"]])

export default __exports__